import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import SectionContainer from '../SectionContainer';
import landingPageIcons from '../landingPageIcons';

import css from './SectionCtaBanner.module.css';

/**
 * A solid-color promo card used to close the homepage: a title, a description, and a single
 * call-to-action button (with a trailing arrow glyph).
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 * @param {string} props.sectionId
 * @param {'ctaBanner'} props.sectionType
 * @param {keyof landingPageIcons?} props.icon optional medallion above the title. Omitted by
 *   the current design, so nothing renders unless content asks for it.
 * @param {Object?} props.title (Field data)
 * @param {Object?} props.description (Field data)
 * @param {Object?} props.callToAction (Field data)
 * @param {Object?} props.appearance
 * @param {Object} props.options
 * @returns {JSX.Element}
 */
const SectionCtaBanner = props => {
  const {
    sectionId,
    className,
    rootClassName,
    icon,
    title,
    description,
    callToAction,
    appearance,
    options,
  } = props;

  const fieldOptions = { fieldComponents: options?.fieldComponents };
  const hasContent = hasDataInFields([title, description, callToAction], fieldOptions);
  const iconSrc = icon && landingPageIcons[icon];

  return (
    <SectionContainer
      id={sectionId}
      className={classNames(rootClassName || css.root, className)}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasContent ? (
        <div className={css.card}>
          {iconSrc ? <img className={css.icon} src={iconSrc} alt="" /> : null}
          <Field data={title} className={css.title} options={fieldOptions} />
          <Field data={description} className={css.description} options={fieldOptions} />
          <div className={css.ctaWrap}>
            <Field data={callToAction} className={css.cta} options={fieldOptions} />
            <img className={css.ctaArrow} src={landingPageIcons.arrowRight} alt="" />
          </div>
        </div>
      ) : null}
    </SectionContainer>
  );
};

export default SectionCtaBanner;
